import { PiUser,PiNotebookLight, PiHeart,PiWallet ,PiLockKey } from "react-icons/pi";
import { SlLocationPin } from "react-icons/sl";
import { MdLogout } from "react-icons/md";
const navItems = [
    { to: '/', label: 'home' , end: true},
    // { to: '/categories', label: 'categories' },
    { to: '/shop', label: 'shop' },
     { to: '/recipes', label: 'recipes' },
    { to: '/about', label: 'about us' },
    { to: '/contact', label: 'contact us' },
     { to: '/blogs', label: 'blogs' },
  ];
const profileItems = [
    { to: '.', label: 'profile',icon : <PiUser size={18}/>},
    { to: 'order', label: 'orders' ,icon : <PiNotebookLight size={18}/>},
    { to: 'wishlist', label: 'wishlist',icon : <PiHeart size={18}/> },
    { to: 'address', label: 'my address' ,icon : <SlLocationPin size={18}/>},
    // { to: 'change-password', label: 'change password',icon : <PiLockKey size={18} /> }, 
    { to: '#', label: 'logout' ,icon : <MdLogout size={18}/> , isAction: true},
  ];
  export {navItems,profileItems}